import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { useSelector } from 'react-redux';
import { addFooter, addHeader, addTitles } from './TemplatePrintModals';

const CustomPrintModal = ({ show, handleClose, title1,title2, content }) => {
    const [pdfUrl, setPdfUrl] = useState(null);
    const { nombre, usuario,rolActivo, roles,id } = useSelector(state => state.sesion);

    //console.log("title1=",title1," title2= ",title2," content= ",content)

    useEffect(() => {
        if (show) {
            generatePdf();
        }
    }, [show, content]);

    const generatePdf = () => {
        const doc = new jsPDF('p', 'pt', 'letter'); // Establecer tamaño de hoja a carta

        const marginLeftRight = 55; // Márgenes izquierdo y derecho
        const marginTop = 35; // Margen superior
        const marginBottom = 75; // Ajustar el margen inferior para bajar el pie de página
        const headerHeight = 60; // Altura de la cabecera
        // Inicializa el número de página
        let pageNumber = 0;
        const titles = {validTitle1:title1||"", validTitle2:title2||""};
        const margins = {marginLeftRight, marginTop, marginBottom};
        
        if (typeof content === 'string') {
            addHeader({doc, pageNumber, headerHeight, marginLeftRight,marginTop});
            doc.text(content, marginLeftRight, marginTop + headerHeight + 40);
            addFooter({doc,marginLeftRight, marginBottom,nombre});
        } else {
            addHeader({doc, pageNumber, headerHeight, marginLeftRight,marginTop});
            const startTableY = addTitles({doc, titles, margins, headerHeight});
            autoTable(doc, {
                head: content.head,
                body: content.body,
                startY:startTableY,
                margin: { top: startTableY, left: marginLeftRight, right: marginLeftRight, bottom: marginBottom }, // Ajustar márgenes para incluir cabecera y pie de página
                didDrawPage: function (data) {
                    pageNumber++;
                    addHeader({doc, pageNumber, headerHeight, marginLeftRight,marginTop});
                    if(pageNumber>1) addTitles({doc, titles, margins, headerHeight});
                    addFooter({doc,marginLeftRight, marginBottom,nombre});
                },
                styles: { 
                    fontSize:9,
                    lineColor: [0, 0, 0], // Color de borde (negro)
                    lineWidth: 0.5, // Grosor del borde más delgado
                },
                headStyles: {
                    fillColor: [255, 255, 255], // Fondo blanco para el encabezado
                    textColor: [0, 0, 0], // Texto negro para el encabezado
                    lineWidth: 0.5, // Grosor del borde del encabezado más delgado
                    lineColor: [0, 0, 0], // Color de borde del encabezado
                },
                bodyStyles: {
                    fillColor: [255, 255, 255], // Fondo blanco para el cuerpo
                    textColor: [0, 0, 0], // Texto negro para el cuerpo
                    lineWidth: 0.5, // Grosor del borde del cuerpo más delgado
                    lineColor: [0, 0, 0], // Color de borde del cuerpo
                },
                pageBreak: 'auto', // Asegurar que el contenido se mueva a una nueva página si es necesario
                rowPageBreak:"avoid"
            });
        }

        const pdfBlob = doc.output('blob');
        const pdfUrl = URL.createObjectURL(pdfBlob);
        setPdfUrl(pdfUrl);
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{title1}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {pdfUrl && (
                    <iframe src={pdfUrl} width="100%" height="500px" title="LISTADO GENERAL"></iframe>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CustomPrintModal;

